/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AddedPostLike, addLike, fetchAllLikes } from '../thunks/likeThunks.ts';

interface likesState {
  likes: AddedPostLike[];
  loading: boolean;
  error: string | null;
}

const initialState: likesState = {
  likes: [],
  loading: false,
  error: null,
};

const likesSlice = createSlice({
  name: 'likes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllLikes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllLikes.fulfilled, (state, action: PayloadAction<AddedPostLike[]>) => {
        state.loading = false;
        state.likes = action.payload;
      })
      .addCase(fetchAllLikes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch likes';
      })
      .addCase(addLike.pending, (state) => {
        state.loading = true;
      })
      .addCase(addLike.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(addLike.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to add like';
      });
  },
});
const likesReducer = likesSlice.reducer;
export default likesReducer;
